import GenericWarning from '../Generic/index'

const EditWarningDialog = props => <GenericWarning {...props} type="edit" />

export default EditWarningDialog
